import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.startsWith('sv') ? 'sv' : 'en';

  return (
    <div className={cn('inline-flex items-center gap-1', className)}>
      <button
        onClick={() => i18n.changeLanguage('sv')}
        className={cn(
          'text-xl rounded-md px-2 py-1 transition-all min-w-[44px] min-h-[44px] flex items-center justify-center',
          currentLang === 'sv'
            ? 'bg-[#2F4E8C]'
            : 'bg-transparent border border-[#D1D5DB]'
        )}
        aria-label="Svenska"
      >
        🇸🇪
      </button>
      <button
        onClick={() => i18n.changeLanguage('en')}
        className={cn(
          'text-xl rounded-md px-2 py-1 transition-all min-w-[44px] min-h-[44px] flex items-center justify-center',
          currentLang === 'en'
            ? 'bg-[#2F4E8C]'
            : 'bg-transparent border border-[#D1D5DB]'
        )}
        aria-label="English"
      >
        🇺🇸
      </button>
    </div>
  );
}
